export const FEE_STATUS_COLOR = {
	"2201 - Arrangement Fee": "#C7D2FE",
	"2101 - Commitment Fee": "#6366F1",
	"2801 - Exit Fee": "#14B8A6",
	"2301 - Extension Fee": "#C084FC",
};
